import(/* webpackMode: "eager" */ "/home/dola/Code/javascript/nextjs/sucre/node_modules/next/dist/client/image-component.js");
